/** AI 工具名 → 用户可读文案。未登记的工具直接显示原始名字。 */
export const TOOL_LABELS: Record<string, string> = {
  list_users: '查询员工',
  query_user_follow_up: '业务员跟进统计',
  query_loan_summary: '放款统计',
  query_channel_analyze: '渠道分析',
  query_loaned_customer_profile: '放款客户画像',
  query_recent_overview: '近期经营总览',
  query_biz_customers: '业务池客户',
  query_customer_events: '客户跟进明细',
  render_chart: '绘制图表',
  get_current_time: '查询当前时间',
};

export function toolLabel(name: string) {
  return TOOL_LABELS[name] || name;
}
